/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import { isMobileOnly } from 'react-device-detect';
import './SplashScreen.scss';
import { Heading } from '@vaisala-rockhopper/components';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Logo } from '../../../../assets/icons/logo_white.svg';

const SplashScreen = () => {
  const { t } = useTranslation('a-parameter-calculator');

  const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === '[::1]' ||
      // 127.0.0.0/8 are considered localhost for IPv4.
      window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
  );

  if (isMobileOnly && !isLocalhost) {
    return (
      <div className="splash-screen">
        <Logo />
        <Heading level={1}>{t('ui.title')}</Heading>
      </div>
    );
  } else return null;
};

export default SplashScreen;
